export default "__VITE_ASSET__mmh40NX1__"